import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <div>
      <div className="footer-wrapper">
        <div className="footer-title">©️OUTPUT BLOG</div>
      </div>
    </div>
  );
};

export default Footer;
